'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';
import categoryFilters from '../../components/filters/category';
import storageFilters from '../../components/filters/storage';

export class DocumentComponent {

  closeWindow: Function;

  data;
  document = {status: 0};
  options;
  products;
  api;
  productSelected;
  storageSelected;
  selected = [];
  storages = [];

  /*
  statuses = [{
    id: 0,
    name: 'Черновик'
  }, {
    id: 1,
    name: 'Проведен'
  }];
  */

  /*@ngInject*/
  constructor($scope, Storage, WindowService, $q) {
    this.Storage = Storage;
    this.scope   = $scope;
    this.Promise = $q.defer;

    this.closeWindow = WindowService.delItem;
    this.scope.deleteRow = this.deleteRow.bind(this);
  }

  $onInit() {
    this.products = this.Storage.getProducts();
    this.document.type = this.data.typeDocument;
    this.document.status = this.data.typeDocument == 'income' ? 1 : 0;

    this.options = {
      primaryKey: '_id',
      enableCellEdit: true,
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      rowEditWaitInterval: -1,
      noUnselect: true,
      data: this.selected,
      onRegisterApi: (gridApi) => {

        this.api = gridApi;

        gridApi.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
          var deferred = this.Promise();
          setTimeout(() => {
            gridApi.rowEdit.setRowsClean([rowEntity]);
            deferred.resolve();
          }, 100);
          return deferred.promise;
        });
      },
      columnDefs: [{
        displayName: '#',
        field: '_id',
        visible: false,
      }, {
        displayName: 'Категоря',
        field: 'categoryId',
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderCategory"></div>',
        visible: false,
        cellEditableCondition: function(){ return false; },
      }, {
        displayName: 'Товар',
        field: 'name',
        cellEditableCondition: function(){ return false; },
      }, {
        displayName: 'Склад',
        field: 'storageId',
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderStorage"></div>',
        cellEditableCondition: function(){ return false; },
      }, {
        displayName: 'Стоимость',
        field: 'amount',
        width: 100,
        cellFilter: 'currency',
        type: 'number', 
      }, {
        displayName: 'Кол-во',
        field: 'count',
        width: 150,
        visible: this.document.type == 'income',
        type: 'number', 
      }, {
        displayName: 'Кол-во (Заказ)',
        field: 'order',
        width: 150,
        visible: this.document.type == 'expenditure',
        type: 'number', 
      }, {
        displayName: '#',
        field: 'status',
        width: 50,
        cellTemplate: '<span style="padding:5px;"><a href="javascript:;" ng-click="grid.appScope.deleteRow(row)"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a></span>',
        cellEditableCondition: function(){ return false; },
      }]
    };
  }

  saveMovements(index) {
    index = index || 0;

    var product = this.selected[index++];

    if( ! product){
      return;
    }

    return this.Storage.saveMovement({
        dtime: new Date(),
        productId: product._id,
        documentId: this.document._id,
        storageId: product.storageId,
        count: (this.document.type == 'income'      ? product.count : 0),
        order: (this.document.type == 'expenditure' ? product.order : 0),
        amount: product.amount,
        comment: ""
      })
      .then(() => {
        return this.saveMovements(index);
      });
  }

  save() {
    return this.Storage.saveDocument(this.document)
      .then((doc) => {
        this.document = doc;
        return this.saveMovements();
      })
      .then(() => {
        this.close();
      })
      .catch(err => {
        console.error(err);
      });
  }

  deleteRow(row) {
    var i = this.selected.indexOf(row.entity);
    this.selected.splice(i, 1);
  }

  close() {
    this.closeWindow(this.data.id);
  }

  onProductSelect() {
    if( ! this.productSelected){
      return;
    }

    this.storages = this.productSelected.storages.filter(item => {
      if(this.document.type == 'income'){
        return true;
      }

      return (item.available || 0) > 0;
    });

    if(this.storages.length > 0){
      this.storageSelected = this.storages[0];
    }

    if(this.storages.length == 1){
      return this.addProduct();
    }
  }

  addProduct() {
    if( ! this.productSelected || ! this.storageSelected) {
      return;
    }

    var sel = this.selected.filter(row => {
      return row._id == this.productSelected._id && row.storageId == this.storageSelected.storageId;
    }).shift();

    if(sel){
      var col = this.options.columnDefs.filter(c => {
        if(this.document.type == 'income'){
          return c.field == 'count';
        } else {
          return c.field == 'order';
        }
      }).shift();

      this.api.selection.selectRow(sel);
      this.api.edit.raise.beginCellEdit(sel, col);
      this.productSelected = undefined;
      return;
    }

    this.selected.push({
      _id: this.productSelected._id,
      categoryId: this.productSelected.categoryId,
      storageId: this.storageSelected.storageId,
      name: this.productSelected.name,
      amount: this.productSelected.amount,
      count: 1,
      order: 1
    });

    this.productSelected = undefined;
    this.storageSelected = undefined;
  }
}

export default angular.module('storageApp.document', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    categoryFilters,
    storageFilters,
  ])
  .component('document', {
    bindings: {data: '='},
    transclude: true,
    template: require('./document.html'),
    controller: DocumentComponent,
    controllerAs: 'documentCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document/document.component.js